import { screenshotApiClient } from './client';
import { handleApiError } from './errors';

export interface CaptureScreenshotRequest {
  url: string;
}

export interface CaptureScreenshotResponse {
  screenshot: string; // base64 encoded
}

export const screenshotApi = {
  /**
   * Capture a screenshot for a URL
   * POST /api/screenshots (JSON)
   */
  async capture(url: string): Promise<CaptureScreenshotResponse> {
    try {
      const response = await screenshotApiClient.post('screenshots', { 
        json: { url }
      }).json();
      
      return response as CaptureScreenshotResponse;
    } catch (error) {
      return await handleApiError(error);
    }
  }
};